/**
 * Resolves a product's primary image URL using the same priority as the
 * product detail page: the first entry in `image_list`, then `image_url`.
 * Returns undefined when neither is set so callers can fall back to a default.
 */
export const getProductImageUrl = (product) => {
    return product?.image_list?.[0]?.url ?? product?.image_url ?? undefined;
};
